import { Pipe, PipeTransform } from '@angular/core';
import { DossierNames, DossierPlaceholderUtils } from '../../core';

@Pipe({
  name: 'dossierPlaceholder'
})
export class DossierPlaceholderPipe implements PipeTransform {
  transform(dossierName: DossierNames, isExample?: boolean): string {
    if (isExample) {
      return DossierPlaceholderUtils.getTranslationKeyForExample(dossierName);
    } else {
      return DossierPlaceholderUtils.getTranslationKey(dossierName);
    }
  }
}
